export const images = {
    Logo: require("../assets/images/Logo.png"),
}
